module.exports = __webpack_public_path__ + "img/card.75e407c5.svg";